const freeFeatures = [
    "pricingFeatures.free.1",
    "pricingFeatures.free.2",
    "pricingFeatures.free.3",
    "pricingFeatures.free.4",
    "pricingFeatures.free.5",
    "pricingFeatures.free.6",
    "pricingFeatures.free.7",
    "pricingFeatures.free.8",
    "pricingFeatures.free.9"
];
const starterFeatures = [
    "pricingFeatures.starter.1",
    "pricingFeatures.starter.2",
    "pricingFeatures.starter.3",
    "pricingFeatures.starter.4",
    "pricingFeatures.starter.5",
    "pricingFeatures.starter.6",
    "pricingFeatures.starter.7",
    "pricingFeatures.starter.8",
    "pricingFeatures.starter.9"
];
const growthFeatures = [
    "pricingFeatures.growth.1",
    "pricingFeatures.growth.2",
    "pricingFeatures.growth.3",
    "pricingFeatures.growth.4",
    "pricingFeatures.growth.5",
    "pricingFeatures.growth.6",
    "pricingFeatures.growth.7",
    "pricingFeatures.growth.8",
    "pricingFeatures.growth.9"
];
const proFeatures = [
    "pricingFeatures.pro.1",
    "pricingFeatures.pro.2",
    "pricingFeatures.pro.3",
    "pricingFeatures.pro.4",
    "pricingFeatures.pro.5",
    "pricingFeatures.pro.6",
    "pricingFeatures.pro.7",
    "pricingFeatures.pro.8",
    "pricingFeatures.pro.9"
];
export const FREE_PLAN = "Free";
export const pricingPlans = [
    {
        id: "1",
        planName: FREE_PLAN,
        duration: "month",
        price: "0 €",
        features: freeFeatures
    },
    {
        id: "2",
        planName: "Package S",
        duration: "month",
        price: "8 €",
        features: starterFeatures
    },
    {
        id: "3",
        planName: "Package M",
        duration: "month",
        price: "12 €",
        features: growthFeatures
    },
    {
        id: "4",
        planName: "Package L",
        duration: "month",
        price: "20 €",
        features: proFeatures
    },
    {
        id: "5",
        planName: FREE_PLAN,
        duration: "year",
        price: "0 €",
        features: freeFeatures
    },
    {
        id: "6",
        planName: "Package S",
        duration: "year",
        price: "76 €",
        features: starterFeatures
    },
    {
        id: "7",
        planName: "Package M",
        duration: "year",
        price: "115 €",
        features: growthFeatures
    },
    {
        id: "8",
        planName: "Package L",
        duration: "year",
        price: "195 €",
        features: proFeatures
    }
];
